import React from 'react';
import bemHelper from 'react-bem-helper';
import './styles.scss';

const bem = bemHelper({ prefix: 'toga-', name: 'vat' });

const VatNumberModule = ({ vatNumber }) => (
    <div {...bem()}>
      <p {...bem('text')}>Registered VAT No.: {vatNumber}</p>
    </div>
);

export default VatNumberModule;



// WEBPACK FOOTER //
// ./src/components/storefront/components/VatNumberModule/VatNumberModule.js